export default "__VITE_ASSET__467618a5__"